// src/utils/paidMessage.js
//
// Mensaje de "pago completado" que se pega en el grupo del PA. Lo usan el cobro
// del cheque (CsrCollection) y la lista de archivos del cheque (CheckFiles), así
// el botón "Copiar mensaje de pagado" sigue a mano después de que el cheque
// pasa a "Comisión cobrada".
import { formatDateToMMDDYYYY } from './dateHelpers';

const usd = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(value) || 0);

export const buildPaidMessage = (check, { total, reference, invoice = check.invoiceNumber, es = true } = {}) => (es
  ? `PAGO COMPLETADO\n\nSe recibió el pago completo del invoice ${invoice}.\n\nCliente: ${check.clientName}\nNúmero de Reclamo: ${check.claimNumber}\nMonto Total: ${usd(total)}\nReferencia: ${reference || '—'}\nFecha del Cheque: ${formatDateToMMDDYYYY(check.checkDate)}\n\nGracias por su pago. El invoice ya quedó completamente saldado.`
  : `PAYMENT COMPLETED\n\nFull payment has been received for invoice ${invoice}.\n\nClient: ${check.clientName}\nClaim Number: ${check.claimNumber}\nTotal Amount: ${usd(total)}\nReference: ${reference || '—'}\nCheck Date: ${formatDateToMMDDYYYY(check.checkDate)}\n\nThank you for your payment. The invoice is now fully settled.`);

// Mensaje de un cheque ya cobrado: total depositado y la referencia del último pago.
export const paidMessageFor = (check, es = true) => {
  const history = check.paymentHistory || [];
  const last = history[history.length - 1];
  return buildPaidMessage(check, { total: check.deposit || check.totalCollected || 0, reference: last?.reference, es });
};
